/** Import modules */

import { useTranslation }       from "react-i18next";

import { Link, useLocation, useParams } from "react-router-dom";

import { 
    
    useEffect, 
    
    useRef, 
    
    useState }                  from "react";

import usePosition              from "../../../Hooks/usePosition";

import { Helmet }               from "react-helmet-async";

import {
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
}                               from "../../../Components/SEO/localizedMeta";

import { getRobotsDirective }   from "../../../Configs/LanguageConfig";

import { buildCategoryPath }     from "../../../Misc/Permalinks";

/** Import models */

import Collection               from "../../../Models/TyresCollection";

/** Import hooks */

import Display                  from "../../../Hooks/ProductDisplay";

/** Import components */

import TyresLayout              from "../../../Components/Products/Tyres/Catalog/Layout";

import Breadcrumbs              from "../../../Components/Layout/Header/Breadcrumbs";

import Products                 from "../../../Components/Products/Tyres/Catalog/Collection";

import Pagination               from "../../../Components/Products/Tyres/Catalog/Pagination";

import Actions                  from "../../../Components/Products/Tyres/Catalog/Actions";

import NoProductsFound          from "../../../Components/Products/Shared/Catalog/NoProductsFound";

import ComponentLoader          from "../../../Components/Layout/Loaders/Loader";

import { gql } from "@apollo/client";

import { useQuery } from "@apollo/client";


const VISUAL_MARKUP_QUERY = gql`query {

    visualMarkup {

        markupPercent

    }

}`;

/**
 * 
 * @returns Blog page
 * 
 */

const TyresCatalog = () => { 


    const { data : visualMarkupData, loading : visualMarkupLoading } = useQuery ( VISUAL_MARKUP_QUERY );

    const 

    location                            = useLocation (),

    routeParams                         = useParams ().parameters,

    { loading, data, error }             = Collection ( routeParams ),

    isMounted                           = useRef ( false ),

    [ notification, setNotification ]   = useState ( 0 ),
    
    { t, i18n }                         = useTranslation (),

    currentLanguage                     = normalizeLanguage(i18n?.resolvedLanguage || i18n?.language),

    categoryPath                        = buildCategoryPath ( "tire" ),

    hasNonLanguageQuery                 = [ ...new URLSearchParams ( location.search ).keys () ].some ( key => key !== "lang" ),

    indexable                           = location.pathname === categoryPath && ! hasNonLanguageQuery,

    canonicalHref                       = localizedAbsoluteUrl ( categoryPath, currentLanguage ),

    alternateLinks                      = hreflangLinks ( categoryPath ),

    robotsDirective                     = indexable ? getRobotsDirective ( currentLanguage ) : "noindex,follow",

    pageDescription                     = localizedValue({
        lv: "Riepu katalogs Tireshop.lv - vasaras, ziemas un vissezonas riepas dažādos izmēros. Izvēlies piemērotāko modeli pēc cenas, ražotāja un pieejamības.",
        en: "Tire catalog at Tireshop.lv - summer, winter, and all-season tires in multiple sizes. Filter by price, brand, and availability.",
        ru: "Каталог шин Tireshop.lv - летние, зимние и всесезонные шины разных размеров. Выбирайте по цене, производителю и наличию."
    }, currentLanguage),

    { layout, setLayout }               = Display (),

    filters                             = useRef ( null ),

    [ 
        
        mobileFilters, 
        
        setMobileFilters ]  = useState ( false ),

    /** Product loader */

    ProductCatalog = () => { if ( loading || visualMarkupLoading ) return <ComponentLoader />

        if ( error || ! data?.multiFieldProductSearch?.edges?.length ) return <NoProductsFound />

        return <Products 
        
            layout={ layout } 

            visualMarkup={ visualMarkupData?.visualMarkup }
        
            products={ data.multiFieldProductSearch.edges } 
        
            notice={ { view: notification, set: setNotification } } />

    };

    useEffect ( () => {

        if (isMounted.current) {
            const timer = setTimeout(() => setNotification ( "" ), 1000);
            return () => clearTimeout(timer);
          } else {

            isMounted.current = true;
          }

    }, [ notification ] );

    usePosition ();

    /** Render component */

    return ( <div className="container max-content-width">

         <Helmet defer={ false }>

            <title>{ `Tireshop.lv | ${ t ( "tyres" ) }` }</title>

            <meta
                name="description"
                content={ pageDescription }
            />

            <meta name="robots" content={ robotsDirective } />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "tyres" ), URI: categoryPath }

        ] } />

        <p className="winter-catalog-link">

            <Link to="/ziemas-riepas">{ t ( "view_winter_tyres" ) }</Link>

        </p>

        <TyresLayout title={ t ( "tyres" ) } filters={ { view: mobileFilters, set: setMobileFilters, element: filters } }>

            <Actions layout={ { view: layout, set: setLayout } } mobile={ { view: mobileFilters, set: setMobileFilters, element: filters } } />

            <ProductCatalog />

            { ! loading && ! error && data?.multiFieldProductSearch &&

                <Pagination

                    pageInfo={ data.multiFieldProductSearch.pageInfo }

                    totalPages={ data.multiFieldProductSearch.totalPages }

                    totalCount={ data.multiFieldProductSearch.totalCount }

                />

            }

        </TyresLayout>
        
    </div> );

}

/** Export component */
 
export default TyresCatalog;
